/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Offers\OffersStats\OfferStatsComponent.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday December 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday December 27th 2023 11:22:55 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/SeenCar/SeenCar.module.css";
import { useEffect, useState } from "react";
import OfferStatsModule from "./OfferStatsModule";
import OfferService from "Services/Offer/OfferService";
import { OfferRowType } from "./OfferRow/OfferRow";
import { OfferUserType } from "Type/offer.type";

type ViewsPageProps = {
    showTimeFilter: boolean,
    userID?: string,
    sellID?: string,
    order?: string,
    orderby?: string,
    page?: number,
    setOrderBy?: Function,
    setOrder?: Function,
    updateURL: boolean,
}

function OfferStatsComponent (props: ViewsPageProps) {
    // const [myOffer, setMyOffer] = useState<OfferRowType[]>([]);
    const [myOffer, setMyOffer] = useState<OfferUserType[]>([]);
    const [myCount, setMyCount] = useState<number>(0);

    useEffect(() => {
        const requestToSend = {
            from: props.orderby ?? "week",
            order: props.order ?? "desc",
            per_page: props.page ? 20*props.page : 20,
            page: 1,
            userid: props.userID,
            sellid: props.sellID,
        };
        // OfferService.getAllOffers(requestToSend).then((res: {count: number, offer: OfferRowType[]}) => {
        OfferService.getAllOffers(requestToSend).then((res: OfferUserType[]) => {
            setMyOffer(res);
            setMyCount(res.length);
            if (props.updateURL) {
                const url = window.location;
                const searchParams = new URLSearchParams(url.search);
                searchParams.set("page", props.page ? props.page.toString() : "1");
                window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            }
        }).catch(err => {
            console.error(err);
        })
    }, [props.userID]);

    return (
        <div className={`${Styles.pageholder}`}>
            <h1>{translator.decode("stats.offers")}</h1>
            <OfferStatsModule showTimeFilter={props.showTimeFilter} myOffer={myOffer} viewCount={myCount} userID={props.userID} order={props.order} orderby={props.orderby} setOrderBy={props.setOrderBy} setOrder={props.setOrder} sellID={props.sellID}/>
        </div>
    )
}

export default OfferStatsComponent;
